<template>
  <div class="hello">
    <div v-if="isBackShow">
      <van-nav-bar
        title="赛事中心"
        left-text="返回"
        left-arrow
        @click-left="onTopClickLeft"
      >
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          slot="right"
          style="font-size:20px;"
        >
          <van-icon style="font-size:20px;" name="wap-home" />
        </a>
      </van-nav-bar>
    </div>
    <div>
      <van-swipe :autoplay="3000" indicator-color="white">
        <!-- v-if="ssInfo.SSID === 'SS240326YG000001'" -->
        <van-swipe-item
          v-if="
            (ssInfo.IMGLIST === undefined || ssInfo.IMGLIST.length === 0) &&
              ssInfo.SSID === 'SS240326YG000001'
          "
        >
          <img
            style="width:100%;"
            :src="'https://www.ptty.com.cn/wap/img/SS240326YG000001/topImg.jpg'"
          />
        </van-swipe-item>
        <van-swipe-item
          v-if="
            (ssInfo.IMGLIST === undefined || ssInfo.IMGLIST.length === 0) &&
              ssInfo.SSID === 'SS240913YG000001'
          "
        >
          <img
            style="width:100%;"
            :src="'https://www.ptty.com.cn/wap/img/SS240913YG000001/topImg.png'"
          />
        </van-swipe-item>
        <van-swipe-item
          v-if="
            (ssInfo.IMGLIST === undefined || ssInfo.IMGLIST.length === 0) &&
              ssInfo.SSID === 'SS240915YG000001'
          "
        >
          <img
            style="width:100%;"
            :src="'https://www.ptty.com.cn/wap/gs.png'"
          />
        </van-swipe-item>

        <van-swipe-item
          v-if="
            (ssInfo.IMGLIST === undefined || ssInfo.IMGLIST.length === 0) &&
              ssInfo.SSID === 'SS241026YG000001'
          "
        >
          <img
            style="width:100%;"
            :src="'https://www.ptty.com.cn/wap/xj.png'"
          />
        </van-swipe-item>
        <van-swipe-item
          v-if="
            (ssInfo.IMGLIST === undefined || ssInfo.IMGLIST.length === 0) &&
              ssInfo.SSID === 'SS241108YG000004'
          "
        >
          <img
            style="width:100%;"
            :src="'https://www.ptty.com.cn/wap/mb.png'"
          />
        </van-swipe-item>
        <!-- v-if="ssInfo.SSID !== 'SS240326YG000001'" -->
        <van-swipe-item v-for="(item, index) in ssInfo.IMGLIST" :key="index">
          <img style="width:100%;" :src="item.IMGURL" />
        </van-swipe-item>
        <div
          class="wzMainDivClass"
          v-if="ssInfo.IMGLIST === undefined || ssInfo.IMGLIST.length === 0"
        >
          <van-swipe-item
            v-if="
              ssInfo.SSID !== 'SS240326YG000001' &&
                ssInfo.SSID !== 'SS240913YG000001' &&
                ssInfo.SSID !== 'SS240915YG000001' &&
                ssInfo.SSID !== 'SS241026YG000001' &&
                ssInfo.SSID !== 'SS241108YG000004'
            "
          >
            <div
              style="text-align: left;position: relative;top: 15px;left: 15px;padding-right: 15px;"
            >
              <img
                src="https://www.ptty.com.cn/wap/logo_b.png?v=20250530"
                style="width:30px"
              />
              <label
                style="position: absolute;left: 50px;font-weight: 700;color: #fff;"
                >跑兔体育</label
              >
              <label style="font-size: 15px;position: relative;top: 22px;">
                天津跑兔体育科技有限公司，从事软件开发、软件销售，专注于体育赛事系统研发，致力于推动体育产业数字化转型，微信公众号：跑兔体育赛事系统。
              </label>
            </div>
          </van-swipe-item>
        </div>
        <!-- <van-swipe-item>2</van-swipe-item>
        <van-swipe-item>3</van-swipe-item>
        <van-swipe-item>4</van-swipe-item> -->
      </van-swipe>
    </div>
    <!-- 广告位 开始 暂时停用-->
    <!-- <div
      style="margin-top: 9px;padding-left: 10px;padding-right: 10px;"
      v-if="ADLIST.length > 0"
    >
      <img
        @click="toAd(ADLIST[0].URL)"
        :src="ADLIST[0].IMGHENG"
        style="width:100%;height:68px;border-radius: 6px;"
      />
    </div> -->
    <!-- 广告位 结束 -->

    <!-- 星耀广告位 开始 -->
    <div
      style="margin-top: 9px;padding-left: 10px;padding-right: 10px;"
      v-if="ssInfo.RYBH === 'ZHTY'"
    >
      <img
        @click="toXywlAdUrl"
        src="https://www.ptty.com.cn/wap/xywlbsyqShopYhq.jpg"
        style="width:100%;height:68px;border-radius: 6px;"
      />
    </div>
    <!-- 星耀广告位 结束 -->

    <div class="titleDiv">
      <p
        style="margin-top: 3px;margin-bottom: 5px;font-size: 17px;font-weight: 600;"
      >
        {{ ssInfo.SSMC }}
      </p>
      <p style="margin-top: 5px;margin-bottom: 5px;">
        <van-tag
          :type="
            ssInfo.BSZT === '1'
              ? 'primary'
              : ssInfo.BSZT === '3'
              ? 'danger'
              : ssInfo.BSZT === '6'
              ? 'warning'
              : ssInfo.BSZT === '7'
              ? 'success'
              : ''
          "
        >
          {{
            ssInfo.BSZT === "-1"
              ? "报名未开始"
              : ssInfo.BSZT === "1"
              ? "报名中"
              : ssInfo.BSZT === "3"
              ? "报名结束"
              : ssInfo.BSZT === "6"
              ? "比赛中"
              : ssInfo.BSZT === "7"
              ? "比赛结束"
              : ""
          }}
        </van-tag>
        <label
          style="color: rgb(118 117 117);float: right;margin-right: 15px;font-size:14px;"
          v-if="ssInfo.FWCS > 100"
        >
          <van-icon name="eye-o" />
          {{ ssInfo.FWCS }}
        </label>
      </p>
      <p
        style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;"
        v-if="ssInfo.BMQSRQ !== undefined && ssInfo.BMQSRQ.length > 0"
      >
        <van-icon name="notes-o" />
        <span style="color:#B2B2B2">报名起始时间：</span>
        &nbsp;&nbsp;&nbsp;
        <span>
          {{ ssInfo.BMQSRQ }}
        </span>
      </p>
      <p
        style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;"
        v-if="ssInfo.BMJZRQ !== undefined && ssInfo.BMJZRQ.length > 0"
      >
        <van-icon name="notes-o" />
        <span style="color:#B2B2B2">报名截止时间：</span>
        &nbsp;&nbsp;&nbsp;
        <span>
          {{ ssInfo.BMJZRQ }}
        </span>
      </p>

      <p
        style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;"
        v-if="ssInfo.BSQSRQ !== undefined && ssInfo.BSQSRQ.length > 0"
      >
        <van-icon name="underway-o" />
        <span style="color:#B2B2B2">比赛日期：</span>
        &nbsp;&nbsp;&nbsp;
        <span>
          {{ ssInfo.BSQSRQ }} 至 {{ ssInfo.BSJZRQ }}
          <div
            style="color:red;margin-left: 145px;"
            v-if="
              ssid ===
                '372b74615172576674755068537965323637457141594a5a423438466d714f32'
            "
          >
            (根据人数暂定)
          </div>
        </span>
      </p>
      <p
        style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;"
        v-if="ssInfo.SQTEL && ssInfo.SQTEL.length > 0"
      >
        <van-icon name="location-o" />
        <span style="color:#B2B2B2">联系人：</span>
        &nbsp;&nbsp;&nbsp;
        <span>{{ ssInfo.SQLXR + " / " + ssInfo.SQTEL }}</span>
      </p>
      <p
        style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;"
        v-if="ssInfo.CITYNAME"
      >
        <van-icon name="location-o" />
        <span style="color:#B2B2B2">举办城市：</span>
        &nbsp;&nbsp;&nbsp;
        <span
          >{{
            ssInfo.SFNAME === ssInfo.CITYNAME
              ? ssInfo.CITYNAME
              : ssInfo.SFNAME + " - " + ssInfo.CITYNAME
          }}{{
            ssid ===
            "6e79312f4e774c6342706673646f62366e39736e493562413832477437646d76"
              ? "（龙南市）"
              : ""
          }}
        </span>
      </p>
      <p style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;">
        <van-icon name="location-o" />
        <span style="color:#B2B2B2">比赛地址：</span>
        &nbsp;&nbsp;&nbsp;
        <span>{{ ssInfo.CGMC }}</span>
      </p>
    </div>

    <!-- 荣誉证书查询 Banner 开始 -->
    <div
      class="zsqy-banner-wrapper"
      @click="navToUrl('zsqy')"
      v-if="ssInfo.ISCERT === '1'"
    >
      <div class="zsqy-banner">
        <!-- 玻璃光晕扫光动画 -->
        <div class="zsqy-glass-shine"></div>
        <div class="zsqy-content">
          <div class="zsqy-icon-wrap">
            <img
              src="https://www.ptty.com.cn/wap/logo_b.png?v=20250530"
              class="zsqy-icon"
            />
          </div>
          <div class="zsqy-text-wrap">
            <div class="zsqy-title">荣誉证书查询</div>
            <div class="zsqy-sub">输入证件号，查询您的获奖证书</div>
          </div>
          <div class="zsqy-arrow">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>
    <!-- 荣誉证书查询 Banner 结束 -->

    <div style="margin-left:10px;margin-right:10px;">
      <van-grid :border="true" :column-num="4">
        <!-- -->
        <van-grid-item
          @click="navToUrl('jjtz')"
          v-if="
            ssid ===
              '3067325176515a596c2f2b6f735468684a7a5a505a39582b4e515056742b6956'
          "
        >
          <img src="https://www.ptty.com.cn/wap/jjtz.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            紧急通知
          </p>
        </van-grid-item>
        <van-grid-item @click="navToUrl('qd')" v-if="ssInfo.ISQD === '1'">
          <img
            src="https://www.ptty.com.cn/wap/hpzgtxz.png"
            style="width:35px"
          />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            签到
          </p>
        </van-grid-item>
        <van-grid-item
          @click="navToUrl('imgzb')"
          v-if="ssInfo.ISIMGZB === '1' && isZbShow === '1'"
        >
          <img src="https://www.ptty.com.cn/wap/imgZb.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            图片直播
          </p>
        </van-grid-item>
        <van-grid-item
          @click="navToUrl('spzb')"
          v-if="ssInfo.ISVIDIOZB === '1' && isZbShow === '1'"
        >
          <img src="https://www.ptty.com.cn/wap/spZb.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            视频直播
          </p>
        </van-grid-item>
        <van-grid-item @click="navToUrl('reportXm')">
          <img src="../../assets/images/xmbm.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            项目报名
          </p>
        </van-grid-item>
        <van-grid-item @click="navToUrl('alreadyBmxx')">
          <img src="../../assets/images/ybm.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            我的项目
          </p>
        </van-grid-item>
        <van-grid-item @click="navToUrl('ssgc')">
          <img src="../../assets/images/ssgc.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            赛事规程
          </p>
        </van-grid-item>
        <van-grid-item @click="navToUrl('mdgs')">
          <img src="../../assets/images/mdgs.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            名单公示
          </p>
        </van-grid-item>
        <van-grid-item @click="navToUrl('cqgs')">
          <img src="../../assets/images/cqgs.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            抽签公示
          </p>
        </van-grid-item>
        <van-grid-item @click="navToUrl('jmd')">
          <img src="../../assets/images/jmd.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            节目单
          </p>
        </van-grid-item>
        <van-grid-item @click="navToUrl('cjc')">
          <img src="../../assets/images/cjc.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 12px;">
            秩序册/成绩册
          </p>
        </van-grid-item>
        <van-grid-item @click="navToUrl('sssk')">
          <img
            src="https://www.ptty.com.cn/wap/logo.png?v=20250530"
            style="width:35px"
          />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            比分直播
          </p>
        </van-grid-item>

        <van-grid-item @click="navToUrl('sszn')">
          <img src="../../assets/images/sszn.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            补充通知
          </p>
        </van-grid-item>

        <van-grid-item @click="navToUrl('jifen')" v-if="ISJFLOGO === '1'">
          <img src="../../assets/images/jifen.png" style="width:35px" />
          <p style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;">
            积分榜
          </p>
        </van-grid-item>

        <van-grid-item @click="navToUrl('txccmd')" v-if="RMDTXFS !== 'TWOCODE'">
          <img
            src="../../assets/images/mdgs.png"
            style="width:35px"
            v-if="RMDTXFS === 'LDTX'"
          />
          <p
            style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;"
            v-if="RMDTXFS === 'LDTX'"
          >
            填写名单
          </p>
        </van-grid-item>
        <van-grid-item
          @click="navToUrl('getCcmdCode')"
          v-if="RMDTXFS === 'TWOCODE'"
        >
          <img
            src="../../assets/images/towcodeccmd.png"
            style="width:35px"
            v-if="RMDTXFS === 'TWOCODE' && ISQUERYTWOCODE === '1'"
          />
          <p
            style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;"
            v-if="RMDTXFS === 'TWOCODE' && ISQUERYTWOCODE === '1'"
          >
            填写二维码
          </p>
        </van-grid-item>

        <van-grid-item
          v-if="
            (ssInfo.ISIMGZB === '0' || isZbShow === '0') &&
              ISJFLOGO === '0' &&
              ssInfo.ISQD !== '1'
          "
        >
        </van-grid-item>

        <van-grid-item
          v-if="
            (ssInfo.ISVIDIOZB === '0' || isZbShow === '0') &&
              ssid !==
                '3067325176515a596c2f2b6f735468684a7a5a505a39582b4e515056742b6956'
          "
        >
        </van-grid-item>
      </van-grid>
    </div>

    <div style="height:100px;width:15px;"></div>

    <!-- 底部导航栏 开始 -->
    <van-tabbar v-model="bottomMenu">
      <van-tabbar-item icon="fire" @click="navToUrl('xmsy')"
        >赛事主页</van-tabbar-item
      >
      <van-tabbar-item icon="star" @click="navToUrl('sssk')"
        >实时数据</van-tabbar-item
      >
      <van-tabbar-item
        icon="photo"
        @click="navToUrl('imgzb')"
        v-if="ssInfo.ISIMGZB === '1' && isZbShow === '1'"
        >图片直播</van-tabbar-item
      >
      <van-tabbar-item
        icon="video"
        @click="navToUrl('spzb')"
        v-if="ssInfo.ISVIDIOZB === '1' && isZbShow === '1'"
        >视频直播</van-tabbar-item
      >
      <van-tabbar-item icon="friends" @click="navToUrl('wd')"
        >我的</van-tabbar-item
      >
    </van-tabbar>
    <!-- 底部导航栏 结束 -->

    <div style="height:150px;width:15px;"></div>

    <!-- 出场名单选择弹出框 开始-->
    <van-action-sheet v-model="ccmdShow" title="请选择组别">
      <div class="content">
        <van-cell
          v-for="(item, index) in ccmdDataList"
          :key="index"
          :title="item.XMJC + '(' + item.SSLX + ')'"
          is-link
          @click="jumpRmdTx(item)"
        />
        <div style="width:15px;height:60px"></div>
      </div>
    </van-action-sheet>
    <!-- 出场名单选择弹出框 结束-->

    <bottom-com></bottom-com>

    <!-- 广告弹出位 -->
    <van-overlay :show="isAdTcc && ADLIST.length > 0" @click="isAdTcc = false">
      <div style="text-align: center;margin-top: 30%;">
        <div style="text-align: right;">
          <img
            src="https://www.ptty.com.cn/wap/close.png"
            style="width: 36px;margin-right: 10%; margin-bottom: 15px;"
            @click="isAdTcc = false"
          />
        </div>
        <img
          @click="toAd(ADLIST[0].URL)"
          :src="ADLIST.length > 0 ? ADLIST[0].IMGSHU : ''"
          style="border-radius: 6px;"
        />
        <div>
          <van-button
            round
            style="width:50%;margin-top:15px;"
            @click="toAd(ADLIST[0].URL)"
            >查看详情</van-button
          >
        </div>
      </div>
    </van-overlay>

    <loading-com />

    <!-- 补充通知弹出框 开始 -->
    <van-dialog
      v-model="noticeShow"
      title=""
      :show-confirm-button="false"
      :show-cancel-button="false"
      class-name="notice-dialog"
    >
      <div class="notice-dialog-content">
        <div class="notice-header">
          <van-icon name="volume-o" class="notice-icon" />
          <span class="notice-title">补充通知</span>
        </div>
        <div class="notice-body">
          <div v-html="noticeContent" class="notice-text"></div>
        </div>
        <div class="notice-footer">
          <van-button
            type="default"
            round
            @click="closeNotice"
            class="notice-btn notice-btn-close"
          >
            我知道了
          </van-button>
          <van-button
            type="primary"
            round
            @click="goToDetail"
            class="notice-btn notice-btn-detail"
          >
            查看详情
          </van-button>
        </div>
      </div>
    </van-dialog>
    <!-- 补充通知弹出框 结束 -->
  </div>
</template>

<script>
import BottomCom from "../commonCom/BottomCom.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
import { Dialog } from "vant";
export default {
  name: "XmIndex",
  components: { LoadingCom, BottomCom },
  data() {
    return {
      ISJFLOGO: "0",
      ccmdShow: false,
      ccmdDataList: "",
      USERDE: "",
      isBackShow: false,
      bottomMenu: 0,
      utilPost: "",
      ssid: "",
      op: "wapGL",
      pageSet: {
        currentPage: 1, //当前页页码
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      search: {
        info: "",
        qslx: "",
        bszt: "",
        ssid: ""
      },
      ssInfo: {},
      RMDTXFS: "TWOCODE",
      ISQUERYTWOCODE: "0",
      ISLDYES: "0",
      routeValue: "",
      ADLIST: [],
      openIdEn: "",
      isAdTcc: false,
      isZbShow: "0",
      noticeShow: false,
      noticeContent: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.search.ssid = this.ssid;
    if (
      this.ssid ===
        "78684278336a685468644676767849494954484c54744161574853667a2f4d6f" ||
      this.ssid ===
        "4f497a4236527a736d747953724f6563794d3370785474536d67464c786e734b"
    ) {
      this.isBackShow = false;
    } else {
      this.isBackShow = true;
    }
    //alert(this.ssid);
  },
  mounted() {
    var openIdEn = localStorage.getItem("openIdEn");
    var that = this;
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    } else {
      this.openIdEn = openIdEn;
    }
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    this.mainData();
  },
  methods: {
    toXywlAdUrl() {
      // 跳转到广告页面
      this.$router.push({ path: "/adIndex" });
      return;
    },
    closeNotice() {
      // 记录用户已查看通知的时间戳，6小时内不再弹出
      var noticeKey = "notice_timestamp_" + this.ssid + this.openIdEn;
      var currentTimestamp = new Date().getTime();
      localStorage.setItem(noticeKey, currentTimestamp.toString());
      this.noticeShow = false;
    },
    goToDetail() {
      // 关闭弹窗并跳转到详情页
      this.closeNotice();
      this.noticeShow = false;
      this.$router.push({
        path: "/ssznIndex",
        query: {
          ssid: this.ssid
        }
      });
    },
    toAd(url) {
      this.isAdTcc = false;
      var busData = {
        openIdEn: this.openIdEn
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称1
          methodName: "czAdHandler" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {});
      window.location.href = url;
    },
    mainData() {
      this.search.ssid = this.ssid;
      var busData = {
        pageSet: this.pageSet,
        search: this.search,
        openIdEn: this.openIdEn
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getSsxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.ssInfo = data.content[0];
        // alert(JSON.stringify(this.ssInfo));
        this.RMDTXFS = data.content[0].RMDTXFS;
        this.ISQUERYTWOCODE = data.content[0].ISQUERYTWOCODE;
        this.ISLDYES = data.lsData.ISLDYES;
        this.ADLIST = data.lsData.ADLIST;
        this.isAdTcc = data.lsData.isAdTcc === "1";
        this.isZbShow = data.lsData.isZbShow;
        this.ISJFLOGO = data.lsData.ISJFLOGO;
        this.noticeContent = data.lsData.BCTZCONTENT;

        // 检查是否有补充通知且是否需要弹出
        if (
          data.lsData.ISQZSHOWTCC === "1" &&
          this.noticeContent &&
          this.noticeContent.length > 0
        ) {
          // 检查用户上次查看通知的时间戳
          var noticeKey = "notice_timestamp_" + this.ssid + this.openIdEn;
          var lastViewedTimestamp = localStorage.getItem(noticeKey);
          var currentTimestamp = new Date().getTime();
          var sixHoursInMs = 10 * 60 * 1000; // 10min的毫秒数

          // 如果没有查看记录，或者距离上次查看已经超过10min，则弹出通知
          if (
            !lastViewedTimestamp ||
            currentTimestamp - parseInt(lastViewedTimestamp) >= sixHoursInMs
          ) {
            this.noticeShow = true;
          } else {
            this.noticeShow = false;
          }
        } else {
          this.noticeShow = false;
        }
      });
    },
    onTopClickLeft() {
      var routeValue = this.routeValue;
      if (
        routeValue === null ||
        routeValue === undefined ||
        routeValue.length === 0
      ) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.push({ path: "/" + routeValue });
      }
    },
    onTopClickRight() {
      var routeValue = localStorage.getItem("routeValue");
      if (
        routeValue === null ||
        routeValue === undefined ||
        routeValue.length === 0
      ) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.push({ path: "/" + routeValue });
      }
    },
    navToUrl(type) {
      switch (type) {
        case "xmsy": {
          this.$router.push({
            path: "/xmIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "alreadyBmxx": {
          this.$router.push({
            path: "/alreadyBmxx",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "reportXm": {
          this.$router.push({
            path: "/reportXm",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "zxc": {
          this.$router.push({
            path: "/changeXmIndex",
            query: {
              ssid: this.ssid,
              queryType: "zxc"
            }
          });
          break;
        }
        case "cjc": {
          this.$router.push({
            path: "/changeXmIndex",
            query: {
              ssid: this.ssid,
              queryType: "cjc"
            }
          });
          break;
        }
        case "cjpm": {
          this.$router.push({
            path: "/changeXmIndex",
            query: {
              ssid: this.ssid,
              queryType: "cjpm"
            }
          });
          break;
        }
        case "sssk": {
          this.$router.push({
            path: "/ssbfIndex",
            query: {
              ssid: this.ssid,
              queryType: "all"
            }
          });
          break;
        }
        case "wd": {
          this.$router.push({ path: "/meIndex" });
          break;
        }
        case "ssgc": {
          this.$router.push({
            path: "/ssgcIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "mdgs": {
          this.$router.push({
            path: "/mdgsIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "cqgs": {
          this.$router.push({
            path: "/cqgsIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "jmd": {
          this.$router.push({
            path: "/jmdIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "sszn": {
          this.$router.push({
            path: "/ssznIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "txccmd": {
          if (this.RMDTXFS !== "LDTX") {
            return;
          }
          var that = this;
          this.utilPost.getOpenId(function(openId) {
            var busData = {};
            var paramData = {
              headerData: {
                ssid: that.ssid,
                op: "wapGL", //反射名称1
                methodName: "getRmdTxfs" //对应的方法名
              },
              busData: busData //参数内容
            };
            that.utilPost.paramData = paramData;
            that.utilPost.sendPost().then(data => {
              console.log(data);
              if (data.isSuccess) {
                var RMDTXFS = data.content.RMDTXFS;
                if (RMDTXFS === "LDTX") {
                  that.ccmdDataList = data.content.DATAS;

                  that.USERDE = data.content.USERDE;
                  that.ccmdShow = true;
                } else {
                  alert("您没有权限");
                }
              } else {
                alert("名单获取失败：" + data.msg);
              }
            });
          });

          break;
        }
        case "imgzb": {
          var url = this.ssInfo.IMGZBURL;
          if (url === undefined || url.length === 0) {
            Dialog.alert({
              title: "提示",
              message:
                "直播将于" +
                this.ssInfo.BSQSRQ +
                "开始，请关注我们，及时了解直播动态"
            }).then(() => {});
            return;
          }
          window.location.href = url;
          // var zburl = encodeURIComponent(url);
          // this.$router.push({
          //   path: "/outPageIndex",
          //   query: {
          //     ssid: this.ssid,
          //     zburl: zburl
          //   }
          // });
          break;
        }
        case "spzb": {
          var url = this.ssInfo.VIDIOZBURL;
          if (url === undefined || url.length === 0) {
            Dialog.alert({
              title: "提示",
              message:
                "直播将于" +
                this.ssInfo.BSQSRQ +
                "开始，请关注我们，及时了解直播动态"
            }).then(() => {});
            return;
          }
          window.location.href = url;
          // var zburl = encodeURIComponent(url);
          // this.$router.push({
          //   path: "/outPageIndex",
          //   query: {
          //     ssid: this.ssid,
          //     zburl: zburl
          //   }
          // });
          break;
        }
        case "txz": {
          this.$router.push({
            path: "/txzIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "qd": {
          this.$router.push({
            path: "/qdGlIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "zsqy": {
          this.$router.push({
            path: "/certGlIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "jjtz": {
          window.location.href =
            "https://mp.weixin.qq.com/s/MIhUaArVP7tywjyayEISdA";
          break;
        }
        case "jifen": {
          this.$router.push({
            path: "/qqYlmJfIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "getCcmdCode": {
          this.$router.push({
            path: "/ccmdCodeIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
      }
    },
    jumpRmdTx(row) {
      this.$router.push({
        path: "/writeTeamRym",
        query: {
          ssid: this.ssid,
          dwid: row.XMNM,
          userde: this.USERDE
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.wzMainDivClass .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 163px;
  text-align: center;
  background-color: #39a9ed;
}
.titleDiv {
  margin-top: 6px;
  margin-bottom: 15px;
  text-align: left;
  padding-left: 15px;
  background: #fff;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 5px;
}
.van-tag {
  font-size: 13px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* 补充通知弹出框样式 */
.notice-dialog-content {
  padding: 0;
}

.notice-header {
  background: linear-gradient(135deg, #ff9800 0%, #ff6b00 100%);
  padding: 20px;
  text-align: center;
  border-radius: 8px 8px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notice-icon {
  font-size: 24px;
  color: #fff;
  margin-right: 8px;
  animation: ring 2s ease-in-out infinite;
}

@keyframes ring {
  0%,
  100% {
    transform: rotate(0deg);
  }
  10%,
  30% {
    transform: rotate(-10deg);
  }
  20%,
  40% {
    transform: rotate(10deg);
  }
}

.notice-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.notice-body {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
  background: #fff;
}

.notice-text {
  line-height: 1.8;
  font-size: 15px;
  color: #333;
  text-align: left;
}

.notice-text p {
  margin: 10px 0;
}

.notice-text strong {
  color: #ff9800;
  font-weight: 600;
}

.notice-footer {
  padding: 15px 20px 20px;
  background: #fff;
  border-radius: 0 0 8px 8px;
  display: flex;
  gap: 10px;
}

.notice-btn {
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  height: 44px;
}

.notice-btn-close {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #e0e0e0;
}

.notice-btn-detail {
  background: linear-gradient(135deg, #ff9800 0%, #ff6b00 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4);
}

/* ====== 荣誉证书查询 Banner ====== */
.zsqy-banner-wrapper {
  margin: 0 10px 10px;
  cursor: pointer;
}

.zsqy-banner {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  background: linear-gradient(135deg, #c066a8 0%, #8b5baa 40%, #e0729a 100%);
  box-shadow: 0 4px 16px rgba(176, 90, 160, 0.4);
}

/* 玻璃扫光动画 */
.zsqy-glass-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(
    105deg,
    transparent 30%,
    rgba(255, 255, 255, 0.18) 50%,
    transparent 70%
  );
  animation: glassShine 3s ease-in-out infinite;
  pointer-events: none;
  z-index: 1;
}

@keyframes glassShine {
  0% {
    left: -100%;
  }
  40% {
    left: 120%;
  }
  100% {
    left: 120%;
  }
}

.zsqy-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  padding: 14px 14px;
  gap: 12px;
}

.zsqy-icon-wrap {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.zsqy-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  filter: brightness(10);
}

.zsqy-text-wrap {
  flex: 1;
  min-width: 0;
}

.zsqy-title {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  line-height: 1.3;
}

.zsqy-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 4px;
  line-height: 1.4;
}

.zsqy-arrow {
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/XmIndex/XmIndex.vue